'use client';

import React__default from 'react';
import { colors } from '../../Colors/index.js';

var MoreIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color;
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width !== null && width !== void 0 ? width : 24, height: height !== null && height !== void 0 ? height : 24, viewBox: '0 0 24 24', fill: 'none' },
        React__default.createElement("path", { d: 'M5 10C3.89533 10 3 10.8953 3 12C3 13.1047 3.89533 14 5 14C6.10467 14 7 13.1047 7 12C7 10.8953 6.10467 10 5 10ZM11.6667 10C10.562 10 9.66667 10.8953 9.66667 12C9.66667 13.1047 10.562 14 11.6667 14C12.7713 14 13.6667 13.1047 13.6667 12C13.6667 10.8953 12.7713 10 11.6667 10ZM18.3333 10C17.2287 10 16.3333 10.8953 16.3333 12C16.3333 13.1047 17.2287 14 18.3333 14C19.438 14 20.3333 13.1047 20.3333 12C20.3333 10.8953 19.438 10 18.3333 10Z', fill: color !== null && color !== void 0 ? color : colors.grey[50] })));
};
var MoreIcon$1 = React__default.memo(MoreIcon);

export { MoreIcon$1 as default };
//# sourceMappingURL=MoreIcon.js.map
